import { gql } from '@apollo/client';

const EDIT_NOTE = gql`
    mutation updateNote($id: ID!, $content: String!){
        updateNote(id: $id, content: $content){
            id
            content
            createdAt
            favoriteCount
            favoriteBy{
                id 
                username
            }
            author {
                username
                id
            }
        }
    }
`;

export { EDIT_NOTE };